const actions = {
	SET_MEMBER: "SET_MEMBER"
};

export default actions;
